import { FunctionComponent, ReactNode } from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { ChakraFeatherIcon } from '@/components/ChakraFeatherIcon';

type InfoCalloutProps = {
  /** Ícone à esquerda. Padrão: ícone de informação. */
  icon?: ReactNode;
  children: ReactNode;
};

export const InfoCallout: FunctionComponent<InfoCalloutProps> = ({
  icon,
  children,
}) => (
  <Flex
    gap={3}
    align="flex-start"
    bg="purple.50"
    borderWidth="1px"
    borderColor="purple.100"
    borderRadius="md"
    px={4}
    py={3}
  >
    <Box flexShrink={0} mt="2px" color="brand.500">
      {icon ?? <ChakraFeatherIcon name="info" size="18px" />}
    </Box>
    <Box fontSize="14px" color="brand.700" lineHeight="short">
      {children}
    </Box>
  </Flex>
);
